import React, { MouseEvent } from "react";
import { Button } from "@chakra-ui/react";
import { useClassroomSessionStore } from "@/stores/v2/classroomSessionStore";

interface StartClassButtonProps {
	classroomName: string;
	disabled: boolean;
}

export function StartClassButton({ classroomName, disabled }: StartClassButtonProps): JSX.Element {
	const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		useClassroomSessionStore.getState().handleShowStartClassModal({
			show: true,
			classroomName: classroomName,
			monitoring: false,
		});
	};

	return (
		<Button onClick={handleClick} isDisabled={disabled} py={0}>
			Start Class
		</Button>
	);
}
